import React from "react";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import Menu from "@civicplus/preamble-ui/lib/Menu";
import GetAppIcon from "@material-ui/icons/GetApp";
import { MeetingFile } from "../EventDetails/MeetingFiles/interfaces";
import AuthenticatedDownloadFileButton from "../EventDetails/MeetingFiles/MeetingFileList/DownloadFileButton";

const useStyles = makeStyles(() => ({
  downloadButton: {
    "& >.MuiButtonBase-root": {
      padding: 0,
      "&:hover": {
        backgroundColor: "inherit",
      },
    },
  },
}));

interface EventDownloadFilesMenuProps {
  id?: string;
  publishedFiles: MeetingFile[];
  cpMediaOnly?: boolean;
  title: string;
  className?: string;
  iconSize?: "small" | "medium" | "large";
}

const EventDownloadFilesMenu: React.FC<EventDownloadFilesMenuProps> = ({
  id,
  publishedFiles,
  cpMediaOnly,
  title,
  className,
  iconSize = "small",
}) => {
  const classes = useStyles();
  const itemsRef = React.useRef<(HTMLDivElement | null)[]>([]);

  return (
    // This span captures the onMouseDown button animation for the Menu so that it doesn't propagate to the row
    // This doesn't need to be accessible since the menu itself is
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span onMouseDown={e => e.stopPropagation()}>
      <Menu
        id={id || "menuBar"}
        icon={<GetAppIcon fontSize={iconSize} color="inherit" />}
        stopPropagation={true}
        title={title}
        className={className}
        closeOnClick={false}
        color="primary"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        size="small"
        items={publishedFiles.map((file, uniqueFileIndex) => ({
          icon: (
            <span
              data-testid="downloadFileButton"
              className={classes.downloadButton}
            >
              <AuthenticatedDownloadFileButton
                ref={el => (itemsRef.current[uniqueFileIndex] = el)}
                hideBtn={true}
                remoteFile={file}
                loaderSize={14}
                cpMediaOnly={cpMediaOnly}
              />
            </span>
          ),
          children: <>{file.type}</>,
          onClick: (e: React.MouseEvent) => {
            e.stopPropagation();
            if (itemsRef && itemsRef.current[uniqueFileIndex]) {
              itemsRef.current[uniqueFileIndex]?.click();
            }
          },
        }))}
        keepMounted={true}
      />
    </span>
  );
};

export default EventDownloadFilesMenu;
